<template>
  <video 
    controls=""
    name="media"
    class="audio"
  >
    <source
      :src="audio"
      :type="type"
    />
  </video>
</template>

<script>
  export default {
    name: 'audio',
    props: [
      'audio',
      'type'
    ]
  }
</script>

<style>
  .audio {
    height: 40px;
    margin-top: 5px;
    margin-bottom: 0;
    outline: 0;
    max-width: 500px;
  }
</style>